import { useEffect, useState } from "react";
import { Sparkles, RefreshCcw, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function AIRecommendations() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const load = async (force = false) => {
    if (force) setRefreshing(true); else setLoading(true);
    try {
      const url = force ? "/ai/recommendations/refresh" : "/ai/recommendations";
      const r = force ? await api.post(url) : await api.get(url);
      setData(r.data);
    } catch (e) {
      // silent
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => { load(false); }, []);

  const recs = data?.recommendations || [];

  return (
    <div className="vx-card p-4 space-y-3" data-testid="ai-recommendations-widget">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded flex items-center justify-center bg-[#a78bfa]/15 border border-[#a78bfa]/40">
            <Sparkles className="w-3.5 h-3.5 text-[#a78bfa]" />
          </div>
          <div className="vx-label">AI Coach</div>
        </div>
        <button
          onClick={() => load(true)}
          disabled={refreshing}
          data-testid="refresh-ai-recs"
          title="Regenerate recommendations"
          className="w-7 h-7 rounded flex items-center justify-center border border-[#1f2937] hover:border-[#374151] hover:bg-[#1f2937] text-[#9ca3af] disabled:opacity-50"
        >
          <RefreshCcw className={`w-3 h-3 ${refreshing ? "animate-spin" : ""}`} />
        </button>
      </div>

      {loading ? (
        <div className="text-xs text-[#6b7280] font-mono py-2">Analyzing your last 30 days…</div>
      ) : recs.length === 0 ? (
        <div className="text-xs text-[#6b7280] font-mono py-2">Log 5+ closed trades to unlock recommendations.</div>
      ) : (
        <ul className="space-y-2.5">
          {recs.slice(0, 3).map((r, i) => (
            <li key={i} className="border-l-2 border-[#a78bfa] pl-3 py-0.5" data-testid={`ai-rec-${i}`}>
              <div className="text-xs font-bold text-[#e5e7eb] leading-tight">{r.title}</div>
              <div className="text-[11px] text-[#9ca3af] mt-0.5 leading-relaxed">{r.detail}</div>
            </li>
          ))}
        </ul>
      )}

      <Link
        to="/analytics"
        data-testid="view-analytics-link"
        className="mt-1 flex items-center justify-between text-[10px] font-mono uppercase tracking-widest text-[#3b82f6] hover:text-[#60a5fa] pt-2 border-t border-[#1f2937]"
      >
        View analytics
        <ChevronRight className="w-3 h-3" />
      </Link>
    </div>
  );
}
